export const bg = "var(--seed-color-manner-temp-l2-bg)";
export const text = "var(--seed-color-manner-temp-l2-text)";